/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignChannelSchema = z.enum(['meta', 'career_site'])

export type CampaignChannelSchema = z.infer<typeof campaignChannelSchema>
